var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.unsyncedCount == 0 ? 'primary' : 'error',"text-color":"white","disabled":""}},[_c('v-avatar',{class:{
            'white font-weight-bold': true,
            'primary--text': _vm.unsyncedCount == 0,
            'error--text': _vm.unsyncedCount != 0
        }},[_vm._v(_vm._s(_vm.unsyncedCount))]),_c('span',[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }